module.exports = __webpack_public_path__ + "media/พร้อมไหม.4f4d7c1b.mp3";